import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2619c49a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2619c49a')) {
      api.createRecord('2619c49a', component.options)
    } else {
      api.reload('2619c49a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2619c49a&", function () {
      api.rerender('2619c49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCdBER602c4z/JS/pricehelp.vue"
export default component.exports